import type { IconDefinition } from '../index.tsx';

export const iconPlusCircle: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconPlusCircle',
  icon: [
    16,
    16,
    [],
    '',
    'M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7 7V4H9V7H12V9H9V12H7V9H4V7H7Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
